/* TILEN produktside i Maison de Sabre-stil (2/10-2026), kun visning:
   1. Mærket ("Spar X kr", "Nyhed") flyttes fra over titlen ind på første billede, øverst til venstre.
   2. En tynd fremdriftslinje under galleriet på mobil i stedet for pile og tæller.
   3. Symbolerne i graveringen ligger bag linket "Tilføj symbol".
   Kører igen, når temaet tegner produktet om (variantskift), fordi elementerne så bliver erstattet. */
(function () {
  function placerMaerke(root) {
    var media = root.querySelector('.product__media-list .product__media-item .product-media-container');
    if (!media) return;
    root.querySelectorAll('.product__info-container [data-tilen-badge], .product__info-container .tilen-nyhed').forEach(function (el) {
      if (!el.textContent.trim()) return;
      el.classList.add('tilen-paa-billede');
      media.appendChild(el);
    });
  }
  function fremdrift(root) {
    var list = root.querySelector('.product__media-list');
    var slider = list && list.closest('slider-component');
    if (!slider || slider.querySelector('.tilen-fremdrift')) return;
    var bar = document.createElement('div');
    bar.className = 'tilen-fremdrift';
    bar.innerHTML = '<span></span>';
    slider.appendChild(bar);
    var fill = bar.firstChild;
    function opdater() {
      var max = list.scrollWidth - list.clientWidth;
      var antal = list.querySelectorAll('.product__media-item').length || 1;
      var del = 1 / antal;
      var p = max > 0 ? list.scrollLeft / max : 0;
      fill.style.width = (100 * del) + '%';
      fill.style.transform = 'translateX(' + (p * (antal - 1) * 100) + '%)';
    }
    list.addEventListener('scroll', opdater, { passive: true });
    opdater();
  }
  function symboler(root) {
    root.querySelectorAll('.tilen-symbols').forEach(function (ul) {
      if (ul.dataset.tilenFoldet) return;
      ul.dataset.tilenFoldet = '1';
      ul.hidden = true;
      var a = document.createElement('a');
      a.href = '#';
      a.className = 'tilen-symbol-link';
      a.setAttribute('role', 'button');
      a.setAttribute('aria-expanded', 'false');
      a.textContent = 'Tilføj symbol';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var aaben = a.getAttribute('aria-expanded') === 'true';
        a.setAttribute('aria-expanded', String(!aaben));
        ul.hidden = aaben;
      });
      ul.parentNode.insertBefore(a, ul);
    });
  }
  function laesMere(root) {
    // Maison: ét kort afsnit og "Læs mere". Afsnittene efter det første beskrivelsesafsnit foldes sammen.
    var info = root.querySelector('.product__info-container');
    if (!info || info.dataset.tilenLaes) return;
    var tekster = [].slice.call(info.querySelectorAll(':scope > .product__description, :scope > p.product__text, :scope > div.product__text'));
    tekster = tekster.filter(function (el) { return el.textContent.trim().length > 12 && !el.querySelector('.tilen-prisfakta, .tilen-undertitel, .tilen-nyhed'); });
    if (tekster.length === 1 && tekster[0].textContent.trim().length > 140) {
      // Ét langt afsnit (padel): vis to linjer og "Læs mere"
      info.dataset.tilenLaes = '1';
      var el = tekster[0]; el.classList.add('tilen-laes-klip');
      var b = document.createElement('a'); b.href = '#'; b.className = 'tilen-laes-mere'; b.setAttribute('role', 'button'); b.textContent = 'Læs mere';
      b.addEventListener('click', function (e) { e.preventDefault(); el.classList.remove('tilen-laes-klip'); b.remove(); });
      el.after(b);
      return;
    }
    if (tekster.length < 2) return;
    info.dataset.tilenLaes = '1';
    var skjul = tekster.slice(1);
    skjul.forEach(function (el) { el.classList.add('tilen-laes-mere-tekst'); el.hidden = true; });
    var a = document.createElement('a');
    a.href = '#'; a.className = 'tilen-laes-mere'; a.setAttribute('role', 'button'); a.setAttribute('aria-expanded', 'false'); a.textContent = 'Læs mere';
    a.addEventListener('click', function (e) { e.preventDefault(); skjul.forEach(function (el) { el.hidden = false; }); a.remove(); });
    skjul[skjul.length - 1].after(a);
  }
  function knapPris(root) {
    // Prisen i købsknappen ("Læg i kurv · 229 kr"), spejlet fra prisen øverst, så den følger variant og tilvalg.
    var info = root.querySelector('.product__info-container');
    var span = root.querySelector('product-form [type="submit"] > span:not(.sold-out-message)');
    if (!info || !span || root.querySelector('[data-jul-total]')) return;
    if (!span.dataset.tilenGrund) span.dataset.tilenGrund = span.textContent.trim();
    var pr = info.querySelector('.price');
    if (!pr) return;
    var el = pr.classList.contains('price--on-sale') ? pr.querySelector('.price__sale .price-item--sale') : pr.querySelector('.price__regular .price-item--regular');
    var v = el ? el.textContent.trim() : '';
    var ny = span.dataset.tilenGrund + (v ? ' · ' + v : '');
    if (span.textContent.trim() !== ny) span.textContent = ny;
  }
  function kør() {
    document.querySelectorAll('product-info').forEach(function (root) {
      // Nam 2/10: hele salgsteksten står fremme (ingen "Læs mere"), og købsknappen siger kun "Læg i kurv" (ingen pris).
      placerMaerke(root); fremdrift(root); symboler(root);
    });
  }
  function start() {
    kør();
    document.querySelectorAll('product-info').forEach(function (root) {
      var vent;
      new MutationObserver(function () { clearTimeout(vent); vent = setTimeout(kør, 60); })
        .observe(root, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
